import { render, staticRenderFns } from "./StorefrontImage.vue?vue&type=template&id=85a9c4da&scoped=true"
import script from "./StorefrontImage.vue?vue&type=script&lang=js"
export * from "./StorefrontImage.vue?vue&type=script&lang=js"
import style0 from "./StorefrontImage.vue?vue&type=style&index=0&id=85a9c4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a9c4da",
  null
  
)

export default component.exports